import { render, staticRenderFns } from "./featurenewsm.vue?vue&type=template&id=4d41cdb7&scoped=true&"
import script from "./featurenewsm.vue?vue&type=script&lang=js&"
export * from "./featurenewsm.vue?vue&type=script&lang=js&"
import style0 from "./featurenewsm.vue?vue&type=style&index=0&id=4d41cdb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41cdb7",
  null
  
)

export default component.exports